// ─── Shared Payment Method Constants ────────────────────────────────────────
// Single source of truth for all payment method data used across the app.

export const PAYMENT_METHODS = [
  { value: 'pix',         label: 'Pix',       icon: 'ri-qr-code-line',             color: 'text-teal-600'    },
  { value: 'boleto',      label: 'Boleto',     icon: 'ri-receipt-line',             color: 'text-orange-600'  },
  { value: 'ted',         label: 'TED',        icon: 'ri-send-plane-line',          color: 'text-sky-600'     },
  { value: 'doc',         label: 'DOC',        icon: 'ri-send-plane-2-line',        color: 'text-indigo-600'  },
  { value: 'debito',      label: 'Débito',     icon: 'ri-bank-card-line',           color: 'text-violet-600'  },
  { value: 'dinheiro',    label: 'Dinheiro',   icon: 'ri-money-dollar-circle-line', color: 'text-emerald-600' },
  { value: 'saque',       label: 'Saque',      icon: 'ri-hand-coin-line',           color: 'text-amber-600'   },
  { value: 'transferencia', label: 'Transferência', icon: 'ri-swap-line',           color: 'text-blue-600'    },
  { value: 'outro',       label: 'Outro',      icon: 'ri-more-2-line',              color: 'text-gray-500'    },
] as const;

export type PaymentMethodValue = typeof PAYMENT_METHODS[number]['value'];

/** Key→label map for quick lookup */
export const PAYMENT_METHOD_LABELS: Record<string, string> = Object.fromEntries(
  PAYMENT_METHODS.map(p => [p.value, p.label])
);

/** Icon map for quick lookup */
export const PAYMENT_METHOD_ICONS: Record<string, string> = Object.fromEntries(
  PAYMENT_METHODS.map(p => [p.value, p.icon])
);

/** Color map for quick lookup */
export const PAYMENT_METHOD_COLORS: Record<string, string> = Object.fromEntries(
  PAYMENT_METHODS.map(p => [p.value, p.color])
);

/** Only the grid options shown in the payment modal (excludes 'transferencia' which is handled separately) */
export const PAYMENT_METHOD_MODAL_OPTIONS = PAYMENT_METHODS.filter(
  p => p.value !== 'transferencia'
);

/** Resolves a raw value to a display label, falling back to the raw value if unknown. */
export function resolvePaymentMethodLabel(value: string | null | undefined): string | null {
  if (!value) return null;
  return PAYMENT_METHOD_LABELS[value] ?? value;
}
